import { bl_fi_entity_sales_credit_limits_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class EntitySalesCreditLimitsImportFileHelperContainerModel extends BaseContainerModel {
    bl_fi_entity_sales_credit_limits_import_file_helper: bl_fi_entity_sales_credit_limits_import_file_helper_RowClass = new bl_fi_entity_sales_credit_limits_import_file_helper_RowClass();
}